import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DISTRICT_LIST, DISTRICT_CHANGE_STATUS, DISTRICT_ADDEDIT, DISTRICT_WOP_LIST, DISTRICT_DELETE } from "../../api/constApi";
import { DistrictListApi, districtChangeStatusApi, AddEditDistrictApi,districtWopListApi, districtDeleteApi } from "../Services/districtService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const districtList = createAsyncThunk(DISTRICT_LIST, async (payload) => {
    const response = await DistrictListApi(payload);
    return response.data;
});

export const districtChangeStatus = createAsyncThunk(DISTRICT_CHANGE_STATUS, async (payload) => {
    const response = await districtChangeStatusApi(payload);
    return response.data;
});

export const addEditDistrict = createAsyncThunk(DISTRICT_ADDEDIT, async (payload) => {
    const response = await AddEditDistrictApi(payload);
    return response.data;
});

export const districtWopList = createAsyncThunk(DISTRICT_WOP_LIST, async (payload) => {
    const response = await districtWopListApi(payload);
    return response.data;
});

export const deleteDistrict = createAsyncThunk(DISTRICT_DELETE, async (payload) => {
    const response = await districtDeleteApi(payload);
    return response.data;
});

export const districtSlice = createSlice({
    name: "district",
    initialState: {
        district: null,
        districtWop: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(districtList.fulfilled, (state, action) => {
            state.district = action?.payload;
        });
        builder.addCase(addEditDistrict.fulfilled, (state, action) => {
            state.district = action?.payload?.Data;
        });
    }
});

export default districtSlice.reducer;

// districtlist selector
export const selectDistrictList = (state) => state?.district?.district;
export const useDistrictList = () => {
  const district = useSelector(selectDistrictList);
  return useMemo(() => district, [district]);
};  